import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const GetProductsQuery = gql`
  query($skip: Int, $limit: Int!, $search: String) {
    products(orderBy: createdAt_DESC, first: $limit, skip: $skip, where: { title_contains: $search }) {
      edges {
        node {
          id
          title
          name
          price
          prices {
            id
            productId
            productVariantId
            currencyId
            priceWithout
          }
          display
          displayStatus
          manufacturer {
            id
            name
          }
          supplier {
            id
            name
          }
          images {
            id
            file
            priority
          }
          videos {
            id
            url
          }
          variants {
            id
            prices
          }
          availabilityId
          availability {
            id
            title
          }
          hideForCountry
          visibleForCustomerGroup
          neverApplyCustomerDiscounts
        }
      }
      aggregate {
        count
      }
    }
  }
`;

const DeleteProductMutation = gql`
  mutation delete($id: String!) {
    deleteProduct(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
  limit: number;
  skip?: number;
  search?: string;
  categoryId?: string;
  filterValues?: Array<string>;
}

interface Response {
  data: any;
}

class ProductsQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  public render() {
    const { products, deleteProduct }: any = this.props;
    return this.props.children({
      products,
      deleteProduct
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(GetProductsQuery, {
    name: 'products',
    options: props => ({
      variables: {
        limit: props.limit,
        skip: props.skip,
        search: props.search || '',
        categoryId: props.categoryId ? props.categoryId : undefined
      }
    })
  }),
  graphql<IInputProps, Response>(DeleteProductMutation, {
    name: 'deleteProduct'
  })
)(ProductsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Products/Products.tsx